import { useRef } from "react";
import "../styles/Products.css";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import { useTranslation } from "react-i18next";

import product1 from "../assets/products/product1.jpg";
import product2 from "../assets/products/product2.jpg";
import product3 from "../assets/products/product3.jpg";
import product4 from "../assets/products/product4.jpg";
import product5 from "../assets/products/product5.jpg";

function Products() {
  const { t } = useTranslation();

  const scrollRef = useRef(null);


  const products = [
    {
      id: 1,
      title: t("product1_name"),
      img: product1
    },
    {
      id: 2,
      title: t("product2_name"),
      img: product2
    },
    {
      id: 3,
      title: t("product3_name"),
      img: product3
    },
    {
      id: 4,
      title: t("product4_name"),
      img: product4
    },
    {
      id: 5,
      title: t("product5_name"),
      img: product5
    }
  ];






  return (
    <>
      <Navbar />

      <section className="products-section">

        {/* PAGE TITLE */}

        <h2 className="products-title">
          {t("products_page_title")}
        </h2>

        {/* PRODUCTS WORKSPACE */}

        <div className="products-wrapper">

          <div
          className="products-scroll"
          ref={scrollRef}
        >

            {products.map((p) => (
              <div
                key={p.id}
                className="product-card"
              >

                {/* PRODUCT IMAGE */}

                <div className="product-image-wrapper">

                  <img
                    src={p.img}
                    alt={p.title}
                  />

                </div>

                {/* PRODUCT TITLE */}

                <div className="product-info">

                  <div className="product-title">

                    <span className="title-accent"></span>

                    <h3>
                      {p.title}
                    </h3>

                  </div>

                </div>

              </div>
            ))}

          </div>

  

        </div>

      </section>

      <Footer />
    </>
  );
}

export default Products;